import React, { useState } from 'react';

const Toggle = () => {
    const [show, setShow] = useState(false)
    return (
        <div>
            <p>{show ? "Hello there!" : "..."}</p>
            <button onClick={() => setShow(!show)}>Show me</button>
        </div>
    )
}

export default Toggle;